import type { PlatformExtensionWeb } from '@elmes/plugin-sdk';
import { elmesPipelineNodeKinds } from './pipelineNodeKinds.js';

/** Elmes web contributions; the build-time slot reads the default export (core vite-plugins/platformExtensions.ts). */
export const elmesWebExtension: PlatformExtensionWeb = {
  pages: [],
  sidebar: [],
  components: {
    CrmPage: () => import('./crm/CrmPage.js'),
  },
  windowablePages: [
    {
      // One launcher entry (gh#1195); authenticated-only, the same gate as the /crm route.
      pluginSlug: 'crm',
      pluginName: 'CRM',
      pluginIcon: 'Contact',
      pageKey: 'CrmPage',
      pageRoute: '/crm',
      label: 'CRM',
      windowable: {
        defaultSize: { width: 840, height: 560 },
        resizable: true,
        maximizable: true,
        minimizable: true,
        icon: 'Contact',
      },
      requiredRole: undefined,
    },
  ],
  // Direct URL, so a /crm deep link does not fall through `*` to /dashboard (gh#1418).
  routes: [{ path: '/crm', component: 'CrmPage' }],
  connectorCatalog: [{ slug: 'parasut', name: 'Paraşüt', description: 'Ön muhasebe & faturalama entegrasyonu' }],
  pipelineNodeKinds: elmesPipelineNodeKinds,
};

export default elmesWebExtension;
